/* Legal pages: rebuild Shopify's policy markup into the Northwoofs layout (tabs, contents list, numbered sections). */
(function(){
  var box=document.querySelector('.shopify-policy__container'); if(!box) return;
  var body=box.querySelector('.shopify-policy__body'); if(!body) return;
  var rte=body.querySelector('.rte')||body;
  var els=[].slice.call(rte.children);

  // 1. English only: start at "(English..." or at the second <h1>
  var start=0, h1s=0;
  for(var i=0;i<els.length;i++){ var t=els[i].textContent||'';
    if(/\(English/i.test(t)){ start=i; break; }
    if(els[i].tagName==='H1'){ h1s++; if(h1s===2){ start=i; break; } } }
  var keep=els.slice(start);

  // 2. title + "last updated"
  var title='', updated='';
  if(keep[0]){ var t0=keep[0].textContent.trim();
    if(keep[0].tagName==='H1'||/\(English/i.test(t0)){ title=t0.replace(/\s*\(English( Translation)?\)\s*/i,'').trim(); keep.shift(); } }
  if(keep[0]&&/^\s*(Privacy Policy)\s*$/i.test(keep[0].textContent)){ if(!title) title=keep[0].textContent.trim(); keep.shift(); }
  if(keep[0]&&/last updated/i.test(keep[0].textContent)&&keep[0].textContent.length<60){ updated=keep[0].textContent.trim(); keep.shift(); }
  if(!title){ var st=box.querySelector('.shopify-policy__title'); title=st?st.textContent.trim():document.title; }
  // drop dividers and "will be replaced" notes at the very end
  while(keep.length&&(keep[keep.length-1].tagName==='HR'||/will be replaced/i.test(keep[keep.length-1].textContent))) keep.pop();
  keep=keep.filter(function(e){ return !(e.tagName==='P'&&/^\s*-{3,}\s*$/.test(e.textContent)); });

  // 3. sections: split at <h2>; if there are none, promote short heading-like paragraphs
  var hasH2=keep.some(function(e){return e.tagName==='H2';});
  var promote=!hasH2&&keep.length>=20; // long texts without headings (privacy policy): short lines act as headings
  function isHead(e,next){ if(hasH2) return e.tagName==='H2'; if(!promote) return false;
    if(e.tagName!=='P') return false; var t=e.textContent.trim();
    return t.length>2&&t.length<=70&&!/[.,:;]$/.test(t)&&!e.querySelector('a')&&next&&next.textContent.trim().length>t.length; }
  var secs=[], cur=null;
  keep.forEach(function(e,i){
    if(e.tagName==='HR') return;
    if(isHead(e,keep[i+1])){ cur={h:e.textContent.trim().replace(/^\d+\.\s*/,''),n:[]}; secs.push(cur); }
    else { if(!cur){ cur={h:'',n:[]}; secs.push(cur); } cur.n.push(e); }
  });

  // 4. build
  var tabsT=document.getElementById('nw-legal-tabs');
  var wrap=document.createElement('div'); wrap.className='nwh lg-page';
  var here=location.pathname.replace(/\/$/,'');
  var tabs=tabsT?tabsT.innerHTML:'';
  var h='<div class="pw lg"><nav class="lg-tabs" aria-label="'+NWT.legal.pages+'">'+tabs+'</nav>'
    +'<div class="lg-head"><h1 class="disp"></h1>'+(updated?'<p></p>':'')+'</div>';
  var named=secs.filter(function(s){return s.h;});
  var toc=named.map(function(s,i){return '<a href="#lg-'+i+'" data-lgs="'+i+'"></a>';}).join('');
  if(named.length>1) h+='<details class="lg-mtoc"><summary>'+NWT.legal.on_this_page+'</summary>'+toc+'</details>';
  h+='<div class="lg-wrap'+(named.length>1?'':' no-toc')+'">'+(named.length>1?'<aside class="lg-toc"><h4>'+NWT.legal.on_this_page+'</h4>'+toc+'</aside>':'')+'<div class="lg-body"></div></div></div>';
  wrap.innerHTML=h;
  wrap.querySelector('.lg-head h1').textContent=title;
  if(updated) wrap.querySelector('.lg-head p').textContent=updated;
  wrap.querySelectorAll('.lg-tabs a').forEach(function(a){ if(a.pathname.replace(/\/$/,'')===here) a.setAttribute('aria-current','page'); });
  wrap.querySelectorAll('[data-lgs]').forEach(function(a){ var s=named[+a.dataset.lgs]; a.textContent=(+a.dataset.lgs+1)+'. '+s.h; });
  var lb=wrap.querySelector('.lg-body'), n=0;
  secs.forEach(function(s){ var sec=document.createElement('section');
    if(s.h){ sec.id='lg-'+n; n++; var h2=document.createElement('h2'); h2.innerHTML='<span>'+n+'.</span>'; h2.appendChild(document.createTextNode(s.h)); sec.appendChild(h2); }
    s.n.forEach(function(e){ sec.appendChild(e); }); lb.appendChild(sec); });
  var last=named[named.length-1];
  if(!last||!/question|contact|fragen|kontakt/i.test(last.h)){ var note=document.createElement('div'); note.className='lg-note'; note.innerHTML=NWT.fmt(NWT.legal.questions,{email:'<a href="mailto:woof@northwoofs.com"><b>woof@northwoofs.com</b></a>'}); lb.appendChild(note); }
  box.replaceWith(wrap);

  // 5. contents: jump + highlight current section
  var links=[].slice.call(wrap.querySelectorAll('.lg-toc a')), sections=[].slice.call(wrap.querySelectorAll('.lg-body section[id]'));
  wrap.addEventListener('click',function(e){ var a=e.target.closest('[data-lgs]'); if(!a) return; e.preventDefault();
    var el=document.getElementById('lg-'+a.dataset.lgs); if(el) el.scrollIntoView({behavior:'smooth',block:'start'});
    var d=a.closest('details'); if(d) d.open=false; });
  if(links.length&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ var id=x.target.id.slice(3); links.forEach(function(l){ l.classList.toggle('on',l.dataset.lgs===id); }); } }); },{rootMargin:'-120px 0px -70% 0px'});
    sections.forEach(function(s){ io.observe(s); });
  }
})();
